// extracted by mini-css-extract-plugin
export default {"lds-ouroboro":"style_lds-ouroboro__-sgex","left":"style_left__88QsA","right":"style_right__6e7dL","anim":"style_anim__iOD2+","lds-ouroboro-rotate":"style_lds-ouroboro-rotate__ssrqn"};